export default (price: number) => Math.floor(price * 0.7);
